<template>
  <Dialog v-model:visible="showModal" class="w-11/12 lg:w-3/5 bg-white shadow rounded-xl" :modal="true" @show="loadAddonStatus">
    <template #header>
      <div class="w-full d2-dialog-header-title">{{lang['components']['Dialog']['AddonDialog']['title']}}</div>
    </template>

    <div class="px-2 lg:px-6">
      <!-- 方案資訊摘要 -->
      <div class="d2-addon-summary">
        <div class="d2-sharing-summary-item">
          <div class="num">{{ addonData.plan_title }}</div>
          <div class="lbl">{{lang['components']['Dialog']['AddonDialog']['current_plan']}}</div>
        </div>
        <div class="d2-sharing-summary-item">
          <div class="num">{{ addonData.base_use_num }}</div>
          <div class="lbl">{{lang['components']['Dialog']['AddonDialog']['base_num']}}</div>
        </div>
        <div class="d2-sharing-summary-item">
          <div class="num" style="color: var(--d2-green);">+{{ addonData.addon_total_num }}</div>
          <div class="lbl">{{lang['components']['Dialog']['AddonDialog']['addon_num']}}</div>
        </div>
        <div class="d2-sharing-summary-item">
          <div class="num blue">{{ addonData.effective_use_num }}</div>
          <div class="lbl">{{lang['components']['Dialog']['AddonDialog']['effective_num']}}</div>
        </div>
      </div>

      <!-- 已加購清單 -->
      <div class="mb-6" v-if="addonData.addons && addonData.addons.length > 0">
        <div class="text-gray-600 font-semibold mb-3">{{lang['components']['Dialog']['AddonDialog']['addon_list']}}</div>

        <div v-for="addon in addonData.addons" :key="addon.addon_id"
          class="d2-addon-active-card" style="margin-bottom: 8px;">
          <div class="d2-addon-active-icon">
            <i class="pi pi-bolt"></i>
          </div>
          <div style="flex: 1; min-width: 0;">
            <div style="font-size: 13px; font-weight: 600; color: var(--charcoal);">
              {{lang['components']['Dialog']['AddonDialog']['activity_plus']}} +{{ addon.extra_use_num }}
              <span v-if="addon.status === 'cancelled'" style="margin-left: 8px; color: var(--amber); font-size: 11px;">({{lang['components']['Dialog']['AddonDialog']['cancelled_tag']}})</span>
            </div>
            <div style="font-size: 11px; color: var(--slate);">
              {{lang['components']['Dialog']['AddonDialog']['purchase_date']}}：{{ addon.insert_time.substring(0, 10) }}
              ｜{{lang['components']['Dialog']['AddonDialog']['expire_date']}}：{{ addon.addon_expire_time.substring(0, 10) }}
            </div>
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            <span style="background: #dcfce7; color: var(--d2-green); padding: 4px 12px; border-radius: 12px; font-size: 11px; font-weight: 600; white-space: nowrap;">
              NT$ {{ addon.amount.toLocaleString() }}/{{lang['components']['Dialog']['AddonDialog']['month']}}
            </span>
            <button v-if="addon.status === 'active'"
              class="d2-disconnect-btn"
              @click="cancelAddon(addon)">
              <i class="pi pi-trash" style="margin-right: 4px;"></i>{{lang['components']['Dialog']['AddonDialog']['cancel_btn']}}
            </button>
          </div>
        </div>
      </div>

      <div v-else-if="!isLoading" class="mb-6 text-center text-gray-400 text-sm py-4">
        {{lang['components']['Dialog']['AddonDialog']['no_addons']}}
      </div>

      <!-- 新增加購區塊 -->
      <hr class="d2-sharing-divider" />
      <div>
        <div style="font-size: 13px; font-weight: 600; color: var(--charcoal); margin-bottom: 12px;">{{lang['components']['Dialog']['AddonDialog']['add_section']}}</div>
        <div class="d2-addon-offer">
          <div style="font-size: 14px; font-weight: 600; color: var(--charcoal); margin-bottom: 4px;">
            {{lang['components']['Dialog']['AddonDialog']['activity_plus']}} +5 / {{lang['components']['Dialog']['AddonDialog']['per_group']}}
          </div>
          <div style="font-size: 12px; color: var(--slate); margin-bottom: 14px;">{{lang['components']['Dialog']['AddonDialog']['price_desc']}}</div>
          <!-- 數量選擇器 -->
          <div class="d2-qty-selector">
            <button
              class="d2-qty-btn"
              :disabled="purchaseQuantity <= 1"
              @click="purchaseQuantity > 1 && purchaseQuantity--">
              −
            </button>
            <div class="d2-qty-display">{{ purchaseQuantity }}</div>
            <button
              class="d2-qty-btn"
              :disabled="purchaseQuantity >= 10"
              @click="purchaseQuantity < 10 && purchaseQuantity++">
              +
            </button>
          </div>
          <!-- 小計提示 -->
          <div v-if="purchaseQuantity > 1" style="font-size: 13px; color: var(--d2-green); font-weight: 600; margin-bottom: 14px;">
            {{ purchaseQuantity }} {{lang['components']['Dialog']['AddonDialog']['groups']}} × NT$ 5,000 = NT$ {{ purchaseTotalPrice.toLocaleString() }}/{{lang['components']['Dialog']['AddonDialog']['month']}}，{{lang['components']['Dialog']['AddonDialog']['activity_plus']}} +{{ purchaseTotalExtra }}
          </div>
          <button
            class="d2-btn d2-btn-green"
            :disabled="isPurchasing"
            @click="purchaseAddon">
            <span v-if="isPurchasing">{{lang['components']['Dialog']['AddonDialog']['purchasing']}}</span>
            <span v-else><i class="pi pi-plus" style="margin-right: 4px;"></i>NT$ {{ purchaseTotalPrice.toLocaleString() }}</span>
          </button>
        </div>
        <div style="margin-top: 8px; font-size: 11px; color: var(--slate);">
          {{lang['components']['Dialog']['AddonDialog']['hint']}}
        </div>
      </div>
    </div>

    <template #footer>
      <div class="d2-btn-row" style="justify-content: flex-end;">
        <button
          class="d2-btn-ghost"
          @click="showModal=false">{{lang['components']['Dialog']['AddonDialog']['close_btn']}}</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
  import Dialog from 'primevue/dialog';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import axios from 'axios'
  import Qs from 'qs'
  import { API_BASE_URL, SITE_BASE_URL } from '../../api/config'

  export default {
    name: 'AddonDialog',
    components: {
      Dialog
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      lang: {
        type: Object,
        required: true
      }
    },
    emits: ['update:show', 'addonChanged'],
    data() {
      return {
        addonData: {
          plan_title: '',
          plan_use_num: 0,
          base_use_num: 0,
          addon_total_num: 0,
          effective_use_num: 0,
          addon_count: 0,
          total_monthly_cost: 0,
          has_card: false,
          addons: []
        },
        isLoading: false,
        isPurchasing: false,
        purchaseQuantity: 1
      }
    },
    computed: {
      showModal: {
        get() {
          return this.show;
        },
        set(val) {
          this.$emit('update:show', val);
        }
      },
      purchaseTotalPrice() {
        return 5000 * this.purchaseQuantity;
      },
      purchaseTotalExtra() {
        return 5 * this.purchaseQuantity;
      }
    },
    methods: {
      loadAddonStatus() {
        this.isLoading = true;
        this.purchaseQuantity = 1;
        axios.post(`${API_BASE_URL}/addon_status.php`,
          Qs.stringify({
            s_code: this.$route.params.id
          }),
          { withCredentials: true }
        ).then((response) => {
          let data = response.data;
          if (data.status == 'success') {
            this.addonData = data.return_data;
          } else if (data.status == 'login') {
            window.location.href = `${SITE_BASE_URL}/logout.php`;
          }
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
      },

      purchaseAddon() {
        if (!this.addonData.has_card) {
          Swal.fire({
            title: this.lang['components']['Dialog']['AddonDialog']['title'],
            text: this.lang['components']['Dialog']['AddonDialog']['no_card'],
            icon: 'warning'
          });
          return;
        }

        let qty = this.purchaseQuantity;
        let totalPrice = this.purchaseTotalPrice;
        let totalExtra = this.purchaseTotalExtra;
        let confirmHtml = this.lang['components']['Dialog']['AddonDialog']['purchase_confirm_multi']
          .replace('{quantity}', qty)
          .replace('{extra}', totalExtra)
          .replace('{price}', totalPrice.toLocaleString());

        Swal.fire({
          title: this.lang['components']['Dialog']['AddonDialog']['purchase_confirm_title'],
          html: confirmHtml,
          icon: 'question',
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonColor: '#22c55e',
          cancelButtonColor: '#9ca3af',
          confirmButtonText: this.lang['components']['Dialog']['AddonDialog']['confirm_btn'],
          cancelButtonText: this.lang['components']['Dialog']['AddonDialog']['cancel_dialog_btn']
        }).then((result) => {
          if (result.isConfirmed) {
            this.isPurchasing = true;
            axios.post(`${API_BASE_URL}/addon_purchase.php`,
              Qs.stringify({
                s_code: this.$route.params.id,
                quantity: qty
              }),
              { withCredentials: true }
            ).then((response) => {
              let data = response.data;
              if (data.status == 'success') {
                Swal.fire({
                  title: this.lang['components']['Dialog']['AddonDialog']['title'],
                  text: data.info,
                  icon: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });
                this.loadAddonStatus();
                this.$emit('addonChanged');
              } else if (data.status == 'login') {
                window.location.href = `${SITE_BASE_URL}/logout.php`;
              } else {
                Swal.fire({
                  title: this.lang['components']['Dialog']['AddonDialog']['title'],
                  text: data.info,
                  icon: 'error'
                });
              }
              this.isPurchasing = false;
            }).catch(() => {
              this.isPurchasing = false;
              Swal.fire({
                title: this.lang['components']['Dialog']['AddonDialog']['title'],
                text: this.lang['components']['Dialog']['AddonDialog']['network_error'],
                icon: 'error'
              });
            });
          }
        });
      },

      cancelAddon(addon) {
        Swal.fire({
          title: this.lang['components']['Dialog']['AddonDialog']['cancel_confirm_title'],
          html: this.lang['components']['Dialog']['AddonDialog']['cancel_confirm_text'].replace('{date}', addon.addon_expire_time.substring(0, 10)),
          icon: 'warning',
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonColor: '#ef4444',
          cancelButtonColor: '#9ca3af',
          confirmButtonText: this.lang['components']['Dialog']['AddonDialog']['confirm_btn'],
          cancelButtonText: this.lang['components']['Dialog']['AddonDialog']['cancel_dialog_btn']
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post(`${API_BASE_URL}/addon_cancel.php`,
              Qs.stringify({
                s_code: this.$route.params.id,
                addon_id: addon.addon_id
              }),
              { withCredentials: true }
            ).then((response) => {
              let data = response.data;
              if (data.status == 'success') {
                Swal.fire({
                  title: this.lang['components']['Dialog']['AddonDialog']['title'],
                  text: data.info,
                  icon: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });
                this.loadAddonStatus();
                this.$emit('addonChanged');
              } else if (data.status == 'login') {
                window.location.href = `${SITE_BASE_URL}/logout.php`;
              } else {
                Swal.fire({
                  title: this.lang['components']['Dialog']['AddonDialog']['title'],
                  text: data.info,
                  icon: 'error'
                });
              }
            }).catch(() => {
              Swal.fire({
                title: this.lang['components']['Dialog']['AddonDialog']['title'],
                text: this.lang['components']['Dialog']['AddonDialog']['network_error'],
                icon: 'error'
              });
            });
          }
        });
      }
    }
  }
</script>
